function setHeight(){
  var height=window.innerHeight;
  document.documentElement.style.setProperty( '--vh', height/100 + 'px');
}

window.addEventListener('DOMContentLoaded', setHeight, false);
window.addEventListener('resize', setHeight, false);

